module.exports = __webpack_public_path__ + "static/media/most_icon.2715ba0e.svg";